export default class Videoplayer {
    constructor() {
        this.videoPlayerElement = null; // Placeholder for the player container
        this.initVideoplayer();
    }

    initVideoplayer() {
        const videoTeasers = document.querySelectorAll('[data-js-video]');
        videoTeasers.forEach(teaser => {
            teaser.addEventListener('click', (event) => this.handleVideoTeaserClick(event));
        });
    }

    handleVideoTeaserClick(event) {
        const teaser = event.currentTarget;
        const videoSrc = teaser.dataset.jsVideo;

        this.showVideoPlayer(videoSrc);
    }

    showVideoPlayer(videoSrc) {
        if (!this.videoPlayerElement) {
            this.videoPlayerElement = document.createElement('div');
            this.videoPlayerElement.classList.add('video-player');
            document.body.appendChild(this.videoPlayerElement);

            const closeButton = document.createElement('button');
            closeButton.classList.add('video-player__close');
            closeButton.setAttribute('data-js-closevideo', 'true');
            closeButton.textContent = '×';
            this.videoPlayerElement.appendChild(closeButton);

            const videoElement = document.createElement('video');
            videoElement.classList.add('video-player__video');
            videoElement.setAttribute('autoplay', '');
            videoElement.setAttribute('controls', '');
            videoElement.setAttribute('muted', '');
            videoElement.setAttribute('controlslist', 'nodownload nofullscreen noremoteplayback nopictureinpicture');
            this.videoPlayerElement.appendChild(videoElement);

            closeButton.addEventListener('click', () => this.closeVideoPlayer());
        }

        const videoElement = this.videoPlayerElement.querySelector('.video-player__video');
        videoElement.src = videoSrc;

        this.videoPlayerElement.classList.add('active');
        document.addEventListener('keydown', this.handleEscapeKey);
    }

    handleEscapeKey = (event) => {
        if (event.key === 'Escape' || event.key === 'Esc') {
            this.closeVideoPlayer();
        }
    };

    closeVideoPlayer() {
        if (this.videoPlayerElement) {
            this.videoPlayerElement.classList.remove('active');
            const videoElement = this.videoPlayerElement.querySelector('.video-player__video');
            videoElement.pause();
            videoElement.src = '';
            document.removeEventListener('keydown', this.handleEscapeKey);
        }
    }
}
